import {SearchTitleMrGreenMiniOrbitBox} from "./search-title.mrgreen.mini-orbit.box";

export const SearchTitleMrGreenCisBox = SearchTitleMrGreenMiniOrbitBox;
